const searchCollator = new Intl.Collator(undefined, {
  sensitivity: 'base',
  numeric: true,
});

const normalizeSearchValue = (value) => String(value ?? '').trim().toLowerCase();

const compareLabels = (left, right) => searchCollator.compare(String(left ?? ''), String(right ?? ''));

const isBoundaryCharacter = (character) => !/[a-z0-9]/i.test(character || '');

const getMatchMetadata = (label, query) => {
  const normalizedLabel = normalizeSearchValue(label);
  const matchIndex = normalizedLabel.indexOf(query);

  if (matchIndex === -1) {
    return {
      matchIndex: -1,
      priority: Number.POSITIVE_INFINITY,
    };
  }

  if (matchIndex === 0) {
    return {
      matchIndex,
      priority: 0,
    };
  }

  const isWordStartMatch = isBoundaryCharacter(normalizedLabel[matchIndex - 1]);

  return {
    matchIndex,
    priority: isWordStartMatch ? 1 : 2,
  };
};

export const sortBySearchPriority = (items, query, getLabel = (item) => item, options = {}) => {
  const list = Array.isArray(items) ? items : [];
  const normalizedQuery = normalizeSearchValue(query);
  const { limit, sortWhenEmpty = false } = options;

  let result;

  if (!normalizedQuery) {
    result = sortWhenEmpty
      ? [...list].sort((left, right) => compareLabels(getLabel(left), getLabel(right)))
      : [...list];
  } else {
    result = list
      .map((item, index) => {
        const rawLabel = String(getLabel(item) ?? '').trim();
        const { matchIndex, priority } = getMatchMetadata(rawLabel, normalizedQuery);

        return {
          item,
          index,
          rawLabel,
          matchIndex,
          priority,
        };
      })
      .filter((entry) => entry.matchIndex !== -1)
      .sort((left, right) => {
        if (left.priority !== right.priority) {
          return left.priority - right.priority;
        }

        if (left.matchIndex !== right.matchIndex) {
          return left.matchIndex - right.matchIndex;
        }

        const labelCompare = compareLabels(left.rawLabel, right.rawLabel);
        if (labelCompare !== 0) {
          return labelCompare;
        }

        return left.index - right.index;
      })
      .map((entry) => entry.item);
  }

  return typeof limit === 'number' ? result.slice(0, limit) : result;
};